
/**
 * @nullable
 */
export type AdminAccountActiveSubscription = {
  /** @nullable */
  endDate?: string | null;
  /**
   * 관리자 UI 표시용 실패 분류 (renewal_payment_failure 등)
   * @nullable
   */
  failureCategory?: string | null;
  id?: number;
  /**
   * 마지막 성공 결제일 (갱신 vs 초기 빌링 분류용)
   * @nullable
   */
  lastPaymentDate?: string | null;
  /**
   * 마지막 결제 결과 메시지 (표시용)
   * @nullable
   */
  lastPaymentResult?: string | null;
  /** @nullable */
  nextBillingDate?: string | null;
  /**
   * 연결 주문의 실패 사유
   * @nullable
   */
  orderFailReason?: string | null;
  /**
   * 현재 활성 구독과 연결된 주문 ID
   * @nullable
   */
  orderId?: string | null;
  /**
   * 결제 플랫폼 (예: NICEPAY, GOOGLE_PLAY)
   * @nullable
   */
  paymentPlatform?: string | null;
  /** @nullable */
  productName?: string | null;
  /** @nullable */
  productPlanCode?: string | null;
  /** @nullable */
  startDate?: string | null;
  /** @nullable */
  status?: string | null;
} | null;
